import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const TrophyIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-trophy', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.89 2.10999H4.10996V3.41667H2.57331C2.24179 3.41667 1.92385 3.54836 1.68943 3.78278C1.45501 4.0172 1.32331 4.33515 1.32331 4.66667V6.33333H1.3233L1.32332 6.33603C1.32423 6.53434 1.37232 6.72959 1.46361 6.90565C1.55452 7.08098 1.68568 7.23226 1.84632 7.34711L4.28715 9.11211C4.34398 9.22021 4.41385 9.32196 4.49585 9.41492L4.52505 9.44801L6.05579 10.7105C6.25477 11.0173 6.39564 11.3561 6.47329 11.71H6.15994C5.70849 11.71 5.44072 12.0818 5.34451 12.3946L4.83737 13.97H11.145L10.6492 12.3962C10.5534 12.0831 10.2855 11.71 9.83328 11.71H9.51361C9.59204 11.356 9.73461 11.0174 9.93601 10.7117L11.475 9.44125L11.5041 9.40825C11.6077 9.29076 11.692 9.15923 11.755 9.01859L14.0607 7.34684C14.2211 7.23203 14.3522 7.08084 14.443 6.90565C14.5343 6.72959 14.5824 6.53434 14.5833 6.33603V4.66667C14.5833 4.33515 14.4516 4.0172 14.2172 3.78278C13.9828 3.54836 13.6648 3.41667 13.3333 3.41667H11.89V2.10999ZM4.10996 7.54425V4.58333H2.57331C2.55121 4.58333 2.53001 4.59211 2.51438 4.60774C2.49876 4.62337 2.48998 4.64457 2.48998 4.66667V6.33134C2.49015 6.34432 2.49335 6.35708 2.49932 6.36861C2.50541 6.38035 2.5142 6.39047 2.52497 6.39814L2.52847 6.40063L2.52846 6.40064L4.10996 7.54425ZM13.3816 6.39812L11.89 7.47968V4.58333H13.3333C13.3554 4.58333 13.3766 4.59211 13.3922 4.60774C13.4079 4.62337 13.4166 4.64456 13.4166 4.66667V6.33134C13.4165 6.34432 13.4133 6.35708 13.4073 6.36861C13.4012 6.38035 13.3924 6.39045 13.3816 6.39812ZM8.38078 11.71C8.47747 11.1042 8.70932 10.5246 9.06277 10.0157L9.10648 9.95281L10.6913 8.64451C10.7478 8.56881 10.778 8.47629 10.7767 8.38118L10.7766 8.37332L10.7766 3.22332H5.2233V8.38785C5.22195 8.48292 5.2521 8.57541 5.30858 8.65109L6.88819 9.95394L6.93264 10.0189C7.28128 10.5281 7.51002 11.1063 7.60583 11.71H8.38078ZM6.23003 12.6677C6.23377 12.6554 6.23765 12.6451 6.24132 12.6367H9.7519C9.75557 12.6451 9.75942 12.6554 9.76316 12.6677L9.88151 13.0433H6.10918L6.22772 12.6753L6.23003 12.6677Z'
      />
    </svg>
  );
};

export default TrophyIcon;
